<db-dialog-wrapper [dialog]="this" [fullScreen]="isMobile" [hasCloseButton]="true"
                   [width]="isMobile? '100vw': isInvite ? '940px' : '480px'" [height]="isMobile ? '100vh':'525px'">
  <div class="db-manage-workspace-users-dialog">
    <div *ngIf="isInvite" class="db-manage-workspace-users-dialog__info-wrap">
      <img src="assets/images/icons/invite_users_bg.svg" alt="">
      <h1 class="db-manage-workspace-users-dialog__title"
          [innerHTML]="smbEnt && !userLocalStorage.inviteVisited && from === 'header' ? ('text_improveYourWebsiteManagementFlow' | dbText)
          : ('text_improveTheWebsiteManagementFlow' | dbText)"></h1>
      <p class="db-manage-workspace-users-dialog__text"
         [innerHTML]="!userLocalStorage.inviteVisited && from === 'header' && agencyFreelancer ? ('text_inviteTeamAndClientsCollaborate' | dbText)
         : !userLocalStorage.inviteVisited && from === 'header' && agencyFreelancer ? ('text_inviteMembersCollaborate' | dbText)
         : ('text_inviteTeamOrMembersCollaborate' | dbText) "></p>
      <div class="db-manage-workspace-users-dialog__info-points-wrap">
        <div class="db-manage-workspace-users-dialog__info-point"
             *ngFor="let point of (!userLocalStorage.inviteVisited && from === 'header' && agencyFreelancer ? pointsAgencyFreelance : pointsSMBEnt)">
          <i class="db-icon db-icon-ds-checkmark-bg"></i>
          <div>
            <p class="db-manage-workspace-users-dialog__text"><b [innerHTML]="point.label"></b></p>
            <p class="db-manage-workspace-users-dialog__text" [innerHTML]="point.description"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="db-manage-workspace-users-dialog__action-wrap"
         [ngClass]="{'select-site': role.value === clientRoles.SITE_DEV, 'update': !isInvite}">
      <div *ngIf="!isInvite" class="db-manage-workspace-users-dialog__header">
        <h3 [innerHTML]="'text_updateUserRole' | dbText"></h3>
      </div>

      <div *ngIf="!isInvite" class="db-manage-workspace-users-dialog__user">
        <div>
          <a class="db-manage-workspace-users-dialog__user-picture">
            <img dbGravatar [email]="userData?.email" size="100" src="" alt=""/></a>
          <div>
            <b [innerHTML]="userData?.name"></b>
            <p [dbTooltip]="userData?.email" [dbTooltipPosition]="'bottom'" [innerHTML]="userData?.email"></p>
          </div>
        </div>
      </div>
      <div *ngIf="isInvite" class="ds-input-wrap db-manage-workspace-users-dialog__input-wrap">
        <input type="email" class="ds-input"
               [formControl]="emails"
               [ngClass]="{'error': (emails.invalid && emails.touched) || serverErrors}"
               [placeholder]="'text_emailAddress' | dbText" x-autocompletetype="email">
        <span class="ds-input-desc" [innerHTML]="'text_usersLimit' | dbText"></span>
        <span *ngIf="emails.invalid && emails.touched && !serverErrors" class="ds-input-error-msg">
          {{emails.errors?.hasValue ? ('text_OwnEmailInviteError' | dbText) :
          emails.errors?.duplicate ? ('text_EmailDuplicate' | dbText) :
            emails.errors?.exceededLimit ? ('text_EmailExceededLimit' | dbText) :
              emails.errors?.toAddress ? ('text_invalidEmail' | dbText) : ('text_requiredEmail' | dbText)}}
        </span>
        <span *ngIf="serverErrors" class="ds-input-error-msg">
          {{('text_EmailsExist' | dbText)}}
        </span>
      </div>

      <div>
        <ds-dropdown [dsDropdownOptions]="roleOptions" dsDropdownPlaceHolder="Select role"
                     [dsDropdownListMaxHeight]="isMobile ? '281px': '245px'" [formControl]="role"></ds-dropdown>
        <div *ngIf="role.value === clientRoles.COMPANY_ADMIN" class="db-manage-workspace-users-dialog__info">
          <i class="db-icon db-icon-ds-info-bg"></i>
          <p><b>Important</b>This user will not receive billing notification emails.</p>
        </div>
        <div *ngIf="role.value === clientRoles.SITE_DEV && !websitesCount"
             class="db-manage-workspace-users-dialog__members">
          <b>You don’t have any websites yet.</b>
          <p>
            You will be able to choose “Members" after creating one.
          </p>
        </div>
      </div>

      <div *ngIf="role.value === clientRoles.SITE_DEV && websitesCount">
        <div class="db-manage-workspace-users-dialog__site-select">

          <div (click)="toggleDropdown()" #selectDropdownToggle class="db-manage-workspace-users-dialog__site-select__toggle">
            <input class="db-fc-input db-manage-workspace-users-dialog__input"
                   [ngClass]="{'db-manage-workspace-users-dialog__input-disabled': selectedWebsites.length === websitesCount}"
                   [formControl]="websiteFilter" placeholder="Select Sites" type="text">
            <i class="db-icon db-icon-ds-arrow-small" (click)="toggleDropdown()" [ngClass]="{'db-icon-arrow-up': toggled}"></i>
          </div>

          <div class="db-manage-workspace-users-dialog__site-select__content" #selectDropdown
               [ngClass]="{'toggled': toggled && filteredWebsites.length}">
            <div dbCustomScrollbar>
              <ul>
                <li *ngFor="let website of filteredWebsites; let i = index" (click)="selectWebsite(website, i)">
                  <a class="db-manage-workspace-users-dialog__site-card">
                    <div class="db-manage-workspace-users-dialog__site-card-image" *ngIf="!website.isNetwork"
                         [ngStyle]="{backgroundImage: 'url(&quot;'+
                         (website?.screenshot && !website?.isLocalhost ?  'data:image/jpg;base64,' + website?.screenshot
                         : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}">
                    </div>
                    <div class="db-manage-workspace-users-dialog__site-card-image" *ngIf="website?.isNetwork && !website.parentId"
                         [ngStyle]="{backgroundImage: 'url(&quot;'+ '../../assets/images/common/multisite_thumbnail.png' + '&quot;)'}">
                      <div>
                        <i class="db-icon db-icon-multisite"></i>
                      </div>
                    </div>
                    <div class="db-manage-workspace-users-dialog__site-card-title">
                      <div>
                        <h1 [innerHTML]="website?.title"></h1>
                        <i class="db-icon db-icon-ds-checkmark-bg" *ngIf="website?.domain_hash"></i>
                      </div>
                      <a [href]="website?.site_url" target="_blank" rel="noopener">{{website?.site_url}}</a>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="db-manage-workspace-users-dialog__selected-sites" [ngClass]="{'update': !isInvite}" dbCustomScrollbar>
          <ul>
            <li *ngFor="let website of selectedWebsites, let i = index" class="list-item">
              <div class="db-manage-workspace-users-dialog__site-card" [ngClass]="{'selected': !website.isNetwork && website.siblingId}">
                <div class="db-manage-workspace-users-dialog__site-card-wrap">
                  <div class="db-manage-workspace-users-dialog__site-card-image" *ngIf="!website.isNetwork"
                       [ngStyle]="{backgroundImage: 'url(&quot;'+
                     (website?.screenshot && !website?.isLocalhost ?  'data:image/jpg;base64,' + website?.screenshot
                     : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}">
                  </div>
                  <div class="db-manage-workspace-users-dialog__site-card-image" *ngIf="website?.isNetwork && !website.parentId"
                       [ngStyle]="{backgroundImage: 'url(&quot;'+ '../../assets/images/common/multisite_thumbnail.png' + '&quot;)'}">
                    <div>
                      <i class="db-icon db-icon-multisite"></i>
                    </div>
                  </div>
                  <div class="db-manage-workspace-users-dialog__site-card-title">
                    <div>
                      <h1 [innerHTML]="website?.title"></h1>
                      <i class="db-icon db-icon-ds-checkmark-bg" [ngClass]="{'icon-black': website.type === 'staging'}"></i>
                    </div>
                    <a [href]="website?.site_url" target="_blank" rel="noopener">{{website?.site_url}}</a>
                  </div>
                </div>
                <div class="db-manage-workspace-users-dialog__site-card-wrap">
                  <ds-dropdown *ngIf="!website.isNetwork && website.siblingId" (click)="changeDropdownPosition($event)"
                               [value]="website?.type === 'staging' ? 'staging' : 'full'" [dsDropdownOptions]="siteAccessOptions"
                               dsDropdownWidth="130px" dsDropdownHeight="36px" [dsDropdownListWidth]="180"
                               [dsDropdownPosition]="toggleFromTop ? 'top' : 'bottom'"
                               (onOptionChoose)="updateSelectedSite($event, website.siblingId, i)"></ds-dropdown>
                  <a class="remove-selected-site" (click)="unselectWebsite(i)">
                    <i class="db-icon db-icon-ds-close"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="db-manage-workspace-users-dialog__btn-wrap">
        <button class="ds-btn-blue" [ngClass]="{'ds-btn-loading': loading}"
                (click)="handleRequest()" [disabled]="role.invalid || emails.invalid
              || (role.value === clientRoles.SITE_DEV && !selectedWebsites.length)">
          <span *ngIf="!loading" [innerHTML]="isInvite ? ('text_inviteUsers' | dbText | lowerCaseSpecificWords) : ('text_update' | dbText | lowerCaseSpecificWords)"></span>
          <span *ngIf="loading" class="ds-spinner-circle"></span>
        </button>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
